import React, { useState, useEffect } from "react";
import { ImagesJson } from "../data/ImagesJson";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const Sliderimages = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  // Auto-slide every 4 seconds
  useEffect(() => {
    if (paused) return;
    const interval = setInterval(() => {
      handleNext();
    }, 4000);
    return () => clearInterval(interval);
  }, [currentIndex, paused]);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? ImagesJson.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === ImagesJson.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div
      className="relative bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-[#0f172a] w-full py-12 px-4 lg:px-16 overflow-hidden"
      id="memories"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      {/* Title */}
      <h1 className="text-center text-3xl md:text-4xl lg:text-5xl font-extrabold mb-10 tracking-wide bg-clip-text text-transparent bg-gradient-to-r from-pink-400 via-purple-400 to-indigo-400 drop-shadow-lg">
        Recollecting Memories
      </h1>

      {/* Active Image */}
      <div className="flex justify-center mb-10">
        <div className="relative card bg-white/90 backdrop-blur-md shadow-xl rounded-2xl p-4 max-w-2xl w-full">
          <AnimatePresence mode="wait">
            <motion.div
              key={currentIndex}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 1.1 }}
              transition={{ duration: 0.6, ease: "easeInOut" }}
            >
              <Link
                to={ImagesJson[currentIndex].route}
                smooth={true}
                duration={500}
                className="block text-center"
              >
                <img
                  src={ImagesJson[currentIndex].src}
                  alt={ImagesJson[currentIndex].title}
                  className="rounded-xl w-full h-[400px] object-contain bg-black shadow-lg hover:shadow-2xl transition-all duration-500"
                />
              </Link>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>

      {/* Thumbnails */}
      <p className="text-center text-sm text-gray-300 italic mb-4">
        Scroll for More Memories ↓
      </p>
      <div className="flex justify-center space-x-3 mb-8 overflow-x-auto scrollbar-hide px-4">
        {ImagesJson.map((image, index) => (
          <motion.div
            key={index}
            className={`flex-shrink-0 cursor-pointer rounded-lg ${
              index === currentIndex
                ? "ring-4 ring-purple-400 scale-110"
                : "opacity-80 hover:opacity-100"
            } transition-all duration-300`}
            whileHover={{ scale: 1.1 }}
            onClick={() => setCurrentIndex(index)}
          >
            <img
              src={image.src}
              alt={image.title}
              className="w-28 h-20 object-contain bg-black rounded-md shadow-md"
            />
          </motion.div>
        ))}
      </div>

      {/* Navigation Buttons */}
      <button
        className="absolute left-2 sm:left-6 top-1/2 transform -translate-y-1/2 bg-gradient-to-r from-indigo-600 to-purple-600 text-white p-3 rounded-full shadow-lg hover:scale-110 transition"
        onClick={handlePrev}
      >
        <FaArrowLeft className="text-lg sm:text-2xl" />
      </button>

      <button
        className="absolute right-2 sm:right-6 top-1/2 transform -translate-y-1/2 bg-gradient-to-r from-purple-600 to-pink-500 text-white p-3 rounded-full shadow-lg hover:scale-110 transition"
        onClick={handleNext}
      >
        <FaArrowRight className="text-lg sm:text-2xl" />
      </button>
    </div>
  );
};

export default Sliderimages;
